import { axiosWithAuth } from "helpers";

export const pendService = {
	getPend,
	addPend,
	updatePend,
	getPendList,
	getPendHistory,
};

const API_URL = process.env.REACT_APP_API_URL;

function getPend(id) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/pends/${id}`,
	};

	return axiosWithAuth(options);
}

function addPend({ name, id, details, reasonIds, pendedToId, pendFrom }) {
	const body = {
		details,
		reasonIds,
		pendedToId,
		[name]: id,
		status: 1,
		pendFrom,
	};

	const options = {
		method: "POST",
		data: body,
		url: `${API_URL}/api/pends`,
	};

	return axiosWithAuth(options);
}

function updatePend({ id, details, response, status, pendedToId, reasonIds }) {
	const body = {
		details,
		response,
		status,
		pendedToId,
		id,
		reasonIds,
	};

	const options = {
		method: "PUT",
		data: body,
		url: `${API_URL}/api/pends`,
	};

	return axiosWithAuth(options);
}

function getPendHistory(page, pageSize, id) {
	const params = {
		page_index: page,
		page_size: pageSize,
	};

	const options = {
		method: "GET",
		params,
		url: `${API_URL}/api/pends/${id}/changes`,
	};

	return axiosWithAuth(options);
}

function getPendList({
	name = "application_id",
	id,
	page = 0,
	pageSize = 50,
	excludeStatuses,
}) {
	const params = {
		page_index: page,
		page_size: pageSize,
		exclude_statuses: excludeStatuses,
		[name]: id, // name: 'merchantId' or 'applicationId'
	};

	const options = {
		method: "GET",
		params,
		url: `${API_URL}/api/pends`,
	};

	return axiosWithAuth(options);
}
